import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, BooleanColumn, ListColumn, TextColumn} from '../../../../shared/Models/columns';
import {Router} from '@angular/router';
import {BackOfficeOrderService} from '../../../Services/order.service';
import {DButton, IButton} from '../../../../shared/card/card.component';
import * as moment from 'moment';
import {SupplierService} from '../../../Services/supplier.service';
import {TranslateService} from '@ngx-translate/core';
import {Order} from '../../../Models/Order';
import {CollectionService} from '../../../Services/collection.service';
import {SystemUser} from '../../../../shared/Models/SystemUser';
import {environment} from '../../../../../environments/environment';
import * as _ from 'lodash';
import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {Helper} from '../../../../helpers/helper.service';
import {NgbCountryDateParserFormatter} from '../../../../shared/Services/NgbCountryDateParserFormatter';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {UsersService} from '../../../Services/users.service';
import {InvoiceLayoutService} from '../../../Services/invoice-layout.service';
import {BackOfficeInvoiceService} from '../../../Services/invoice.service';
import {NgForm} from '../../../../../../node_modules/@angular/forms';
import {InternalPackagingLabelService} from '../../../Services/internal-packaging-label.service';
import {DealerProfileService} from '../../../Services/dealer-profile.service';
import {ContactFunctionService} from '../../../Services/contact-function.service';

const baseUri = environment.apiUrl;
const URL = baseUri + '/backoffice/order/uplode-delivery-week?file=resource.file';

@Component({
  selector: 'app-backoffice-quote-overview',
  templateUrl: './backoffice-order-overview.component.html',
  styleUrls: ['./backoffice-order-overview.component.scss'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbCountryDateParserFormatter}
  ],
})
export class BackofficeOrderOverviewComponent implements OnInit {
  public grid: Grid;
  public params;
  public messages: string[] = [];
  public baseUrl = environment.apiUrl;
  public shouldBeConfirmed = false;
  public selectedOrderIds: number[] = [];
  public templates = [];
  public selectedTemplate;
  public OrderObj = Order;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  @ViewChild('uploadModal', {static: false}) uploadModal;
  @ViewChild('confirmActionModal', {static: false}) confirmModal;
  @ViewChild('importResultModal', {static: false}) importResultModal;
  @ViewChild('gridComponent', {static: false}) gridComponent;
  @ViewChild('priceTemp', {static: true}) priceTemp;
  @ViewChild('packingListTemp', {static: true}) packingListTemp;
  @ViewChild('productionFormsTemp', {static: true}) productionFormsTemp;
  @ViewChild('isInvoicedTemp', {static: true}) isInvoicedTemp;
  @ViewChild('statusTmp', {static: true}) statusTmp;
  @ViewChild('uploadEl', {static: false}) uploadElRef: ElementRef;
  @ViewChild('notifyModal', {static: false}) notifyModal;
  @ViewChild('generateInvoiceModal', {static: false}) generateInvoiceModal;
  @ViewChild('generateInvoiceForm', {static: false}) generateInvoiceForm: NgForm;
  @ViewChild('exportEmailsModal', {static: false}) exportEmailsModal;
  public uploader: FileUploader = new FileUploader({
    // itemAlias: 'image',
    url: URL,
    authToken: this.auth.getBearerHeader(),
  });

  public selectedContactFunction = null;
  public selectedDealerProfile = null;

  constructor(
    private orderService: BackOfficeOrderService,
    private invoiceLayoutService: InvoiceLayoutService,
    private invoiceService: BackOfficeInvoiceService,
    private router: Router,
    private supplierService: SupplierService,
    private translator: TranslateService,
    private userService: UsersService,
    private auth: AuthenticationService,
    private helper: Helper,
    private internalPackagingLabelService: InternalPackagingLabelService,
    private dealerProfileService: DealerProfileService,
    private contactFunctionService: ContactFunctionService,
    private collectionService: CollectionService,
    private authService: AuthenticationService,
  ) {
  }

  public specialButton: IButton[] = [];
  public specialButtonArray;
  public dropdownButton: DButton;
  public dropdownItemsList: any;
  public selectedDealers: SystemUser[];
  public confirmOrderIds = [];
  public notifyOrderIds = [];

  public addFileItem = false;
  public isUploading = false;
  private target: any;
  public isNotAdd = false;
  public isGeneratingInvoice = false;
  selectedFile: any;

  @ViewChild('expectedDeliveryWeekTemp', {static: true}) expectedDeliveryWeekTemp: ElementRef;
  @ViewChild('rowDetail', {static: true}) rowDetail: any;
  public dealerProfileItems: any[];
  contactFunctionItems: any[];
  @ViewChild('collectionsTemp', {static: true}) collectionsTemp: ElementRef;

  ngOnInit() {
    // dealer profiles
    this.dealerProfileService.getProfiles().subscribe(resp => {
      this.dealerProfileItems = resp.data.map(item => ({label: item.name, value: item.id}));
    });

    // contact functions
    this.contactFunctionService.getContactFunctions().subscribe(resp => {
      this.contactFunctionItems = resp.data.map(item => ({label: item.title, value: item.id}));
    });

    this.uploader.onAfterAddingFile = (item => {
      this.uploadElRef.nativeElement.value = '';
      if (this.target) {
        this.target.value = '';
      }
      item.withCredentials = false;
    });
    const dateFormat = this.auth.getDateFormat();
    this.grid = <Grid>{
      columns: [
        <BooleanColumn>{
          type: BooleanColumn.type,
          sortable: false,
          maxWidth: 30,
        },
        <TextColumn>{
          name: 'doctrine.order.date',
          prop: 'created',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          width: 110,
          minWidth: 110,
          maxWidth: 120,
          valueFormatter: row => moment(row).format(dateFormat),
        },
        <TextColumn>{
          name: 'doctrine.order.number',
          prop: 'orderNo',
          sortable: true,
          width: 122,
          minWidth: 122,
          maxWidth: 180,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.order.reference',
          prop: 'reference',
          sortable: true,
          width: 100,
          minWidth: 95,
          maxWidth: 220,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.order.dealer',
          prop: 'user',
          sortable: true,
          type: TextColumn.type,
          width: 112,
          minWidth: 113,
          maxWidth: 250,
          translate: true,
          filterable: true,
          filterItems: this.getDealers(),
          filterMultiSelect: true,
          valueFormatter: row => row?.companyName?.charAt(0)?.toUpperCase() + row?.companyName?.slice(1)
        },
        <TextColumn>{
          name: 'doctrine.model.supplier',
          prop: 'supplier',
          sortable: false,
          type: TextColumn.type,
          width: 90,
          minWidth: 90,
          maxWidth: 160,
          translate: true,
          filterable: true,
          filterItems: this.getSuppliers(),
          filterMultiSelect: true,
          valueFormatter: row => row?.companyName
        },
        <TextColumn>{
          name: 'doctrine.collection.collections',
          prop: 'orderItemCollections',
          sortable: false,
          type: TextColumn.type,
          width: 90,
          minWidth: 90,
          maxWidth: 160,
          translate: true,
          filterable: true,
          filterItems: this.getCollections(),
          filterMultiSelect: true,
          valueTemplate: this.collectionsTemp,
        },
        <TextColumn>{
          name: 'doctrine.order.expected_delivery_week',
          prop: 'expectedDeliveryWeek',
          sortable: true,
          type: TextColumn.type,
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          translate: true,
          filterable: true,
          filterItems: this.getDeliveryWeeks(),
          filterMultiSelect: true,
          valueTemplate: this.expectedDeliveryWeekTemp
        },
        <TextColumn>{
          name: 'doctrine.order.is_production_forms_generated',
          prop: 'productionFormsStatus',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          width: 45,
          minWidth: 45,
          maxWidth: 80,
          filterable: true,
          filterItems: [{value: 0, label: this.translator.instant('global.no')}, {value: 1, label: this.translator.instant('global.yes')}],
          filterMultiSelect: false,
          valueTemplate: this.productionFormsTemp
        },
        <TextColumn>{
          name: 'doctrine.order.is_packaging_label_generated',
          prop: 'hasPackagingLabel',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          width: 45,
          minWidth: 45,
          maxWidth: 80,
          filterable: true,
          filterItems: [{value: 0, label: this.translator.instant('global.no')}, {value: 1, label: this.translator.instant('global.yes')}],
          filterMultiSelect: false,
          valueTemplate: this.packingListTemp
        },
        <TextColumn>{
          name: 'doctrine.order.isInvoiced',
          prop: 'isInvoiced',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          width: 50,
          minWidth: 50,
          maxWidth: 100,
          filterable: true,
          filterItems: [{value: 0, label: this.translator.instant('global.no')}, {value: 1, label: this.translator.instant('global.yes')}],
          filterMultiSelect: false,
          valueTemplate: this.isInvoicedTemp

        },
        <TextColumn>{
          name: 'global.status',
          prop: 'status',
          sortable: true,
          type: TextColumn.type,
          width: 70,
          minWidth: 70,
          maxWidth: 130,
          translate: true,
          filterable: true,
          filterItems: this.getStatuses(),
          filterMultiSelect: true,
          valueTemplate: this.statusTmp
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          width: 90,
          minWidth: 90,
          maxWidth: 100,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              tooltip: 'global.view',
              onclick: row => this.router.navigateByUrl('back-office/order/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/order/' + row.id + '/edit'),
              showCallback: row => row.status !== Order.CANCELLED['key'] && row.status !== Order.CHANGED['key'] && row.status !== Order.SPLIT['key'],
              btnClass: 'ripple light ms-1'
            },
            <ActionItem>{
              icon: 'fa fa-repeat fa-lg',
              tooltip: 'global.exchange',
              onclick: row => {
                if(this.auth.isBackOffice()) return this.router.navigateByUrl('/back-office/order/exchange/' + row.id + '/add');
                else return this.router.navigateByUrl('/dealer-system/order/exchange/' + row.id + '/add');
              },
              showCallback: row => !!row,
              disabledCallback: row => !row?.isExchangeable,
              btnClass: 'ripple light ms-1'
            },
          ]
        },
      ],
      service: this.orderService,
      rememberURL: this.router.url,
      method: 'getBackofficeOrders',
      root: 'order',
      defaultSort: 'id',
      bulkActionMethod: 'bulkAction',
      rowDetailTemplate: this.rowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch: true,
      multipleRowSearch: false,
      search: [
        <GridSearchItem>{
          calendarFromDate: 'from',
          calendarToDate: 'to',
          hasCalendar: true,
          type: 'ng-select',
          hasDropdownListFilter: true,
          hasStatus: false,
          hasNormalSearch: true,
          order: [
            {actionOrder: 1, datepickerOrder: 2, normalSearchOrder: 3}
          ],
        }
      ],
    };

    this.specialButtonArray = [
      {
        name: this.translator.instant('admin.order.new'),
        btnIcon: 'feather icon-plus',
        method: 'newOrder',
        customClass: 'btn-primary'
      },
      // {
      //   name: this.translator.instant('admin.order.production_forms'),
      //   btnIcon: 'feather icon-file-text',
      //   method: 'generateProductionForms',
      //   customClass: 'btn-grey'
      // },
      // {
      //   name: this.translator.instant('admin.order.delivery_export'),
      //   btnIcon: 'feather icon-download',
      //   method: 'exportDeliveryOrders',
      //   customClass: 'btn-grey'
      // },
      {
        name: this.translator.instant('admin.order.import_delivery_weeks'),
        btnIcon: 'feather icon-upload',
        method: 'importDelivery',
        customClass: 'btn-grey'
      },
      {
        name: this.translator.instant('admin.order.send_email'),
        btnIcon: 'feather icon-mail',
        method: 'sendDeliveryEmails',
        customClass: 'btn-grey'
      },
    ];

    this.dropdownItemsList = [
      {
        btnName: this.translator.instant('admin.order.export.dropdown_layout_1'),
        method: 'exportOrders',
        key: Order.layout_1
      },
      {
        btnName: this.translator.instant('admin.order.export.dropdown_layout_2'),
        method: 'exportOrders',
        key: Order.layout_2
      },
      {
        btnName: this.translator.instant('admin.order.export.dropdown_layout_3'),
        method: 'exportOrders',
        key: Order.layout_3
      },
      {
        btnName: this.translator.instant('admin.order.export.dropdown_layout_4'),
        method: 'exportOrders',
        key: Order.layout_4
      },
      {
        // Carpet layout for the rug supplier — dimensions live on the order line,
        // so they can never reach the option-driven layouts (FR-042)
        btnName: this.translator.instant('admin.order.export.dropdown_layout_6'),
        method: 'exportOrders',
        key: Order.layout_6
      },
      {
        // POS insurance: the insurer's registration file. The backend (US-607) names the
        // file and sets its content type, and exportIt() only forwards {path, name} to
        // /download — so a .csv needs no special handling on this side.
        btnName: this.translator.instant('admin.order.export.dropdown_layout_7'),
        method: 'exportOrders',
        key: Order.layout_7
      },
    ];

    this.dropdownButton = {
      name: this.translator.instant('admin.order.export'),
      dropdownItems: [...this.dropdownItemsList]
    };

    this.specialButtonArray.forEach(items => {
      this.specialButton.push({
        btnIcon: items.btnIcon,
        btnName: items.name,
        btnUrl: items.btnUrl,
        method: items.method,
        btnCustomClass: items.customClass
      });
    });

    this.invoiceLayoutService.getActiveLayoutList(false).subscribe(res => {
      this.templates = [];
      res.data.map(template => {
        this.templates.push({
          label: template.name,
          value: template.id,
        });
      });
    });
  }

  onFileSelected() {
    this.selectedFile = this.uploader.queue[0].file.rawFile;
  }


  calFunction(method: string) {
    this[method]();
  }

  setParams(event) {
    this.params = event;
  }

  importDelivery() {
    this.uploadModal.show();
  }

  sendDeliveryEmails() {
    this.orderService.sendDeliveryEmails().subscribe(res => {
      this.checkOrderConfirm(res);
    });
  }

  public async exportOrders(dropDownLayout) {
    this.params = this.params.delete('layout');
    this.params = this.params.append('layout', dropDownLayout.key);
    if (dropDownLayout.key === Order.layout_5) {
      this.exportEmailsModal.show();
      return;
    }
    this.exportIt();
  }

  public async exportDeliveryOrders() {
    await this.exportOrders({key: Order.layout_delivery});
  }

  newOrder() {
    this.router.navigateByUrl('/back-office/order/add');
  }

  checkOrderConfirm(res) {
    if (Helper.isDefined(res.orders) && (Helper.isDefined(res.orders.notify) || Helper.isDefined(res.orders.confirm))) {
      if (Helper.isDefined(res.orders.notify) && res.orders.notify.length > 0) {
        if (Helper.isDefined(res.orders.confirm)) {
          this.shouldBeConfirmed = true;
          this.prepareConfirmOrderIds(res.orders);
        } else {
          this.shouldBeConfirmed = false;
        }
        this.prepareNotifyOrderIds(res.orders);

      } else if (res.orders.confirm !== undefined && res.orders.confirm.length > 0) {
        this.prepareConfirmOrderIds(res.orders);
        this.confirmModal.show();
      }

    } else if (res.csv !== undefined) {
      const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
      el.setAttribute('download', 'download');
      el.setAttribute('href', this.baseUrl + '/download?path=' + res.path
        + '&filename=' + res.name);
      el.click();
    } else if (Helper.isDefined(res.file)) {
      const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
      el.setAttribute('download', 'download');
      el.setAttribute('href', this.baseUrl + '/download?path=' + res.file.publicPath + '&filename=' + res.file.fileName);
      el.click();
    } else if (res.packagingLabel !== undefined) {
      if (res.noStocks.length > 0) {
        const messages = [this.translator.instant('admin.backoffice.order.overview.packaging_label_can_not_be_generated')];
        messages.push('&nbsp;');
        res.noStocks.forEach(orderNo => {
          messages.push(orderNo);
        });
        this.helper.popMessageDialog(
          this.translator.instant('global.fail_message.title'),
          messages,
          'error',
          true
        );
      } else if (res.errors.length > 0) {
        this.helper.popMessageDialog(
          this.translator.instant('global.fail_message.title'),
          this.translator.instant('admin.backoffice.order.overview.packaging_label_already_generated'),
          'error',
          false
        );
      } else if (res.success.length > 0) {
        this.helper.popMessageDialog(
          this.translator.instant('global.success_message.title'),
          this.translator.instant('admin.backoffice.order.overview.packaging_label_generated'),
          'success',
          false
        );
      }
    } else if (res.delivery_change !== undefined) {
      if (res.success.length > 0) {
        const messages = [this.translator.instant('admin.backoffice.order.overview.delivery_update_sent')];
        messages.push('&nbsp;');
        res.success.forEach(orderNo => {
          messages.push(orderNo);
        });
        this.helper.popMessageDialog(
          this.translator.instant('global.success_message.title'),
          messages,
          'success',
          true
        );
      } else if (res.errors.length > 0) {
        const messages = [this.translator.instant('admin.backoffice.order.overview.delivery_not_updated')];
        messages.push('&nbsp;');
        res.errors.forEach(orderNo => {
          messages.push(orderNo);
        });
        this.helper.popMessageDialog(
          this.translator.instant('global.fail_message.title'),
          messages,
          'error',
          true
        );
      } else if (res.success.length === 0) {
        this.helper.popMessageDialog(
          this.translator.instant('global.fail_message.title'),
          this.translator.instant('admin.order.no_delivery_updated'),
          'error',
          false
        );
      }
    }
  }

  prepareConfirmOrderIds(orders) {
    this.selectedDealers = [];
    this.confirmOrderIds = [];
    orders.confirm.forEach(order => {
      this.selectedDealers.push(order.user);
      this.confirmOrderIds.push(order.id);
    });
    this.selectedDealers = _.unionBy(
      this.selectedDealers,
      'id'
    );
  }

  prepareNotifyOrderIds(orders) {
    this.notifyOrderIds = [];
    orders.notify.forEach(order => {
      this.notifyOrderIds.push(order.id);
    });
    this.notifyModal.show();
  }

  hideNotifyModal() {
    this.notifyModal.hide();
    if (this.shouldBeConfirmed) {
      this.confirmModal.show();
    }
  }

  confirm() {
    this.gridComponent.confirmAction = true;
    this.gridComponent.selectedIds = this.confirmOrderIds;
    this.gridComponent.bulkAction();
    this.confirmModal.hide();
  }

  confirmChange() {
    this.gridComponent.notifyAction = true;
    this.gridComponent.selectedIds = this.notifyOrderIds;
    this.gridComponent.bulkAction();
    this.notifyModal.hide();
    if (this.shouldBeConfirmed) {
      this.confirmModal.show();
    }
  }

  selectInvoiceLayout(selectedIds) {
    this.selectedOrderIds = selectedIds;
    this.generateInvoiceModal.show();
    this.generateInvoiceForm.resetForm();
  }

  generateInvoice() {
    this.isGeneratingInvoice = true;
    const params = {action: Order.GENERATE_INVOICE_ACTION, ids: this.selectedOrderIds, layout: this.selectedTemplate};
    this.orderService.bulkAction(params).subscribe(res => {
      this.isGeneratingInvoice = false;
      this.generateInvoiceModal.hide();
      this.gridComponent.selectedIds = [];
      this.gridComponent.checkedAll = false;
      if (res?.invoice !== undefined) {
        if (res?.errors?.length > 0) {
          this.helper.popMessageDialog(
            this.translator.instant('global.fail_message.title'),
            res?.errors,
            'error',
            true
          );
        } else if (res?.success?.length > 0) {
          this.helper.popMessageDialog(
            this.translator.instant('global.success_message.title'),
            this.translator.instant('admin.backoffice.order.overview.invoice_generated'),
            'success',
            false
          );
        }
      }
    });
  }

  uploadFile() {
    this.addFileItem = true;
    this.isUploading = true;
    this.uploader.uploadAll();
    this.uploader.onErrorItem = (item: FileItem, response, status: number, headers: ParsedResponseHeaders) => {
      this.addFileItem = false;
      if (status === 401) {
        this.handle401Error();
      } else {
        this.isUploading = false;
        this.uploader.clearQueue();
        this.uploadElRef.nativeElement.value = '';
        const res = JSON.parse(response);
        this.helper.popMessageDialog(res.title, res.errors);
      }
    };
    this.uploader.onSuccessItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      if (response) {
        const res = JSON.parse(response);
        this.uploadModal.hide();
        this.addFileItem = false;
        this.isUploading = false;
        this.isNotAdd = false;
        this.uploader.clearQueue();
        this.messages = [];
        let ordersCount = 0;
        if (res?.orders?.objects !== undefined) {
          ordersCount = res.orders.objects.length;
        }
        this.messages.push(ordersCount + ' ' + this.translator.instant('admin.backoffice.order.import_successfully'));
        if (res?.orders?.errors !== undefined) {
          res.orders.errors.forEach(error => {
            const isCancelled = error?.startsWith('#');
            const orderId = isCancelled ? error?.substring(1) : error;

            const statusKey = isCancelled
              ? 'admin.backoffice.order.import_cancelled'
              : 'admin.backoffice.order.import_failed';

            const orderLabel = this.translator.instant('doctrine.attributes.order');
            const statusMessage = this.translator.instant(statusKey);

            let finalMessage = `${orderLabel} ${orderId} ${statusMessage}`;
            if (isCancelled) {
              finalMessage = `* ${finalMessage} *`;
            }

            this.messages.push(finalMessage);
          });
        }
        this.importResultModal.show();
      }
    };
  }

  resetUploader() {
    this.uploader.clearQueue();
    this.uploader.addToQueue([this.selectedFile]);
  }

  private handle401Error(): void {
    this.authService.refreshToken().subscribe((token) => {
        this.resetUploader();
        this.uploader.authToken = 'Bearer ' + token.token;
        this.uploadFile();
      }, error => {
        this.isUploading = false;
      }
    );

  }

  cancelUpload() {
    this.uploader.clearQueue();
    this.uploadElRef.nativeElement.value = '';
    this.uploadModal.hide();
  }

  getInvoicePdf(row) {
    if (row?.invoices && row.invoices[0]) {
      this.invoiceService.getPdf(row.invoices[0].invoiceNo).subscribe((resp) => {
      });
    }
  }

  getPdf(item) {
    if (item && item.labelFile) {
      const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
      el.setAttribute('href', this.baseUrl + '/download?path='
        + item.labelFile.path + '&filename=' + item.labelFile.filename);
      el.setAttribute('download', this.baseUrl + '/download?path=' + item.labelFile.filename);
      el.click();
    }
  }

  getDealers() {
    const options = [];
    this.userService.getAllDealerUsersDropdown({sortType: 'ASC', sortBy: 'companyName'}).subscribe((res) => {
      for (const row of res) {
        options.push({value: row.id, label: row.companyName});
      }
    });
    return options;
  }

  getSuppliers() {
    const options = [];
    this.supplierService.getSupplier().subscribe((res) => {
      for (const row of res.data) {
        options.push({value: row.id, label: row.companyName});
      }

    });
    return options;
  }

  getCollections() {
    const options = [];
    this.collectionService.getCollections().subscribe((res) => {
      for (const row of res.data) {
        options.push({value: row.id, label: row.name});
      }

    });
    return options;
  }

  getDeliveryWeeks() {
    const options = [];
    this.orderService.getDeliveryWeeks().subscribe((res) => {
      for (const row of res) {
        options.push({value: row.datetime, label: row.label});
      }
    });
    return options;
  }

  getStatuses() {
    return [
      {label: this.translator.instant('doctrine.order.statuses.' + Order.NEW['key']), value: Order.NEW['key']},
      {label: this.translator.instant('doctrine.order.statuses.' + Order.IN_PROCESS['key']), value: Order.IN_PROCESS['key']},
      {label: this.translator.instant('doctrine.order.statuses.' + Order.DELIVERY['key']), value: Order.DELIVERY['key']},
      {label: this.translator.instant('doctrine.order.statuses.' + Order.COMPLETED['key']), value: Order.COMPLETED['key']},
      {label: this.translator.instant('doctrine.order.statuses.' + Order.ON_HOLD['key']), value: Order.ON_HOLD['key']},
      {
        label: this.translator.instant('doctrine.order.statuses.' + Order.FREE_DELIVERY_AMOUNT_NOT_REACHED['key']),
        value: Order.FREE_DELIVERY_AMOUNT_NOT_REACHED['key']
      },
      {label: this.translator.instant('doctrine.order.statuses.' + Order.CANCELLED['key']), value: Order.CANCELLED['key']},
      {label: this.translator.instant('doctrine.order.statuses.' + Order.CHANGED['key']), value: Order.CHANGED['key']},
    ];
  }

  generateProductionForms() {
    this.internalPackagingLabelService.generateProductionForms().subscribe();
  }

  exportIt() {
    this.params = this.params.delete('dealerProfile');
    this.params = this.params.delete('contactFunction');
    this.params = this.params.append('dealerProfile', this.selectedDealerProfile ? this.selectedDealerProfile.value : null);
    this.params = this.params.append('contactFunction', this.selectedContactFunction ? this.selectedContactFunction.value : null);
    this.orderService.exportOrders(this.params).subscribe(res => {
      // US-613: the POS export now returns no file at all when nothing in the selection
      // qualified, so the download link is only followed when the server actually named
      // one -- otherwise the browser was sent to /download?path=undefined. Every other
      // layout still always returns name/path, so this is a no-op for them.
      if (res.name && res.path) {
        const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
        el.setAttribute('download', 'download');
        el.setAttribute('href', this.baseUrl + '/download?path=' + res.path
          + '&filename=' + res.name);
        el.click();
      }
      this.showExportSummary(res);
    });
  }

  /**
   * US-613: tell the user what the export did with their selection -- how many of the
   * selected orders produced a row, and why the rest did not.
   *
   * Only the POS layout sends `summary`/`message`; every other layout returns name/path
   * alone and this stays silent, exactly as before. The reason labels are read from the
   * server's own catalogue (admin.pos.export.skipped.*, added with the endpoint), so the
   * dialog and the exporter can never disagree about what "already_exported" means, and a
   * reason added server-side later needs no change here beyond its translation.
   *
   * `message` is the server's own sentence and is already translated; it leads, and the
   * per-reason counts follow it as a list.
   */
  private showExportSummary(res) {
    const summary = res.summary;
    const skipped = (summary && summary.skipped) || [];
    if (!res.message && !skipped.length) {
      return;
    }
    const messages = [];
    if (res.message) {
      messages.push(res.message);
    }
    skipped.forEach(entry => messages.push(
      this.translator.instant('admin.pos.export.skipped.' + entry.reason) + ': ' + entry.count
    ));
    // Nothing was written at all -- the user gets no download, so say so as a warning
    // rather than dressing a failed export up as a success.
    const nothingExported = !!summary && summary.rows === 0;
    this.helper.popMessageDialog(
      this.translator.instant(nothingExported ? 'admin.pos.export.error' : 'admin.pos.export.success'),
      messages,
      nothingExported ? 'warning' : 'info'
    );
  }

  getCollectionBadge(collectionsString: string, asTitle = false) {
    if (collectionsString) {
      const collections = collectionsString?.split(',');
      if (asTitle || collections?.length < 2) {
        return collectionsString;
      } else {
        return collections?.length + ' ' + this.translator.instant('doctrine.collection.collections');
      }
    }
  }
}
